import type im from "immutable";

import { joinPath } from "~/components/inspectorv2/traverseValue/ValuePath";

import { type FieldSet, type QueryBuilderState } from "./QueryBuilderState";
import { type QueryableField } from "./QueryableField";

/**
 * A `groupby` node in a query.
 */
export interface GroupBy {
	groupedFields: FieldSet;
	groupedFieldOrdering: im.List<QueryableField>;
}

export const appendGroupedFields = (
	s: QueryBuilderState | null,
	fields: QueryableField[]
): QueryBuilderState | null => {
	if (!s) {
		return s;
	}

	let { groupedFieldOrdering, groupedFields } = s.get("groupedFields");
	for (const f of fields) {
		const path = joinPath(f.path);
		if (groupedFields.has(path)) {
			continue;
		}

		groupedFields = groupedFields.set(path, f);
		groupedFieldOrdering = groupedFieldOrdering.push(f);
	}

	return s.set("groupedFields", { groupedFieldOrdering, groupedFields });
};

export const replaceGroupedField = (
	s: QueryBuilderState | null,
	index: number,
	field: QueryableField
): QueryBuilderState | null => {
	if (!s) {
		return s;
	}

	const { groupedFieldOrdering, groupedFields } = s.get("groupedFields");
	const f = groupedFieldOrdering.get(index);
	if (!f) {
		return s;
	}

	return s.set("groupedFields", {
		groupedFieldOrdering: groupedFieldOrdering.set(index, field),
		groupedFields: groupedFields.delete(joinPath(f.path)).set(joinPath(field.path), field),
	});
};

export const deleteGroupedField = (
	s: QueryBuilderState | null,
	index: number
): QueryBuilderState | null => {
	if (!s) {
		return s;
	}

	const { groupedFieldOrdering, groupedFields } = s.get("groupedFields");
	const f = groupedFieldOrdering.get(index);
	if (!f) {
		return s;
	}

	return s.set("groupedFields", {
		groupedFieldOrdering: groupedFieldOrdering.delete(index),
		groupedFields: groupedFields.delete(joinPath(f.path)),
	});
};
